<template>
    <v-container fluid class="ma-0 pa-0">
        <v-row no-gutters style="flex-wrap: nowrap;">
            <v-col cols="2" class="flex-grow-0 flex-shrink-0">
                <v-card outlined
                        tile>
                    <!--<v-navigation-drawer permanent>-->
                        <FilterList></FilterList>
                        <!--</v-navigation-drawer>-->
                </v-card>
            </v-col>
            <v-col cols="1"
                   style="min-width: 100px; max-width: 100%;"
                   class="flex-grow-1 flex-shrik-0">
                <VuePerfectScrollbar class="drawer-menu--scroll leftRightMainContainer">
                    <v-card outlined
                            tile>
                        <StarRatingMeasureChart v-on:next="next" style="height:100%"></StarRatingMeasureChart>
                    </v-card>
                    <v-card outlined
                            tile>
                        <DataTable :headerData="headerData" :tableData="tableData" :showQuestionNumber="false"></DataTable>
                    </v-card>
                 </VuePerfectScrollbar>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import { mapState } from 'vuex';
    import FilterList from "../FilterList";
    import StarRatingMeasureChart from '../Charts/StarRatingMeasureChart'
    import DataTable from '../DataTable'
    import '../../../../assets/BenchmarkBuilderStyles.css'

    export default {
        components: {
            FilterList,
            StarRatingMeasureChart,
            DataTable,
            VuePerfectScrollbar
        },
        data() {
            return {
                drawer: null,
                active: null,
                panel: []
                //,
                //settings: {
                //    maxScrollbarLength: 60
                //}
            }
        },
        computed: {
            binding() {
                const binding = {}
                if (this.$vuetify.breakpoint.mdAndUp) binding.column = true
                return binding
            },
            ...mapState({
                headerData: state => state.YourDataStore.headerData,
                tableData: state => state.YourDataStore.tableData,
            }),
        },
        methods: {
            next() {
                //this.$emit('next');
                this.$router.push('/Medicare/Benchmark');
            }
        },
        created() {
            this.$store.dispatch('AppStore/SetTab', this.TAB_YOUR_DATA);
        }
    };
</script>
<style scoped>
    .drawer-menu--scroll {
        overflow: auto;
    }

    .scroll-area {
        position: absolute;
        margin: auto;
    }
</style>